<template>
  <div class="employees">
    <div class="employees__title">Сотрудники</div>
    <div
      v-if="!isMobile"
      class="employees__item employees__item--title">
      <div class="employees__panel">
        <div class="employees__avatar"></div>
        <div class="employees__name">
          <button
            @click="sortEmployees('name')"
            type="button">
            Имя
          </button>
        </div>
        <div 
          :class="[
            'employees__group',
            {'employees__group--width': hidePriceAccess}
          ]"
        >
          <div class="employees__email">E-mail</div>
          <div class="employees__phone">Телефон</div>
          <div class="employees__post">Должность</div>
          <div class="employees__role">Роль</div>
          <template v-if="hidePriceAccess">
            <div class="employees__price">
              <div>
                Скрывать цены
              </div>
              <div>
                <span>на ГИ</span>
                <span>на опт</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <ul class="employees__list">
      <li
        v-for="employee in getFilteredEmployees"
        :key="employee.id"
        class="employees__item">

        <button
          v-if="isMobile"
          @click="toggleSection(employee.id)"
          :class="[
            {'active': section === employee.id},
            'employees__section'
          ]"
          type="button">
          <div
            class="employees__avatar">
            {{ employee.name | getFio }}
          </div>
          <div
            class="employees__name">
            {{ employee.name }}
          </div>
          <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path clip-rule="evenodd" d="M16.192 4.6a.55.55 0 10-1.1 0v10.45H4.642a.55.55 0 100 1.1h10.45V26.5a.55.55 0 101.1 0V16.15h10.35a.55.55 0 100-1.1h-10.35V4.6z"/></svg>
        </button>

        <div
          :class="[
            {'active': section === employee.id},
            'employees__panel'
          ]">
          <div
            v-if="!isMobile"
            class="employees__avatar">
            {{ employee.name | getFio }}
          </div>
          <div
            v-if="!isMobile"
            class="employees__name">
            {{ employee.name }}
          </div>
          <div 
            :class="[
              'employees__group',
              {'employees__group--width': hidePriceAccess}
            ]"
          >
            <div class="employees__email">
              <span v-if="isMobile">E-mail:</span>
              <a :href="`mailto:${employee.email}`">{{ employee.email }}</a>
            </div>
            <div class="employees__phone">
              <span v-if="isMobile">Телефон:</span>
              {{ employee.phone }}
            </div>
            <div class="employees__post">
              <span v-if="isMobile">Должность:</span>
              {{ employee.position }}
            </div>
            <div class="employees__role">
              <span v-if="isMobile">Роль:</span>
              {{ !employee.role ? '-' : employee.role.name }}
            </div>
            <template v-if="hidePriceAccess">
              <div class="employees__price">
                <button
                @click="hidePriceZgi(employee.id, employee.hide_price_zgi)"
                :class="{'active': employee.hide_price_zgi}"
                :disabled="isDisabledBtn(employee.id)"
                type="button"
                >
              </button>
              <button
                @click="hidePrice(employee.id, employee.hide_price)"
                :class="{'active': employee.hide_price}"
                :disabled="isDisabledBtn(employee.id)"
                type="button"
              />
            </div>
          </template>
          </div>
          <MenuAction
            v-if="isEdingAccessPage || isViewAccessPage"
            @menuToggle="menuActionToggle(employee.id)"
            @positionView="positionView(employee)"
            @positionEdit="showUserDataModal(employee)"
            @positionDelete="togglePopupDelete(employee)"
            :open="menuActionIndex !== null && menuActionIndex === employee.id"
            :list="setActionMenu(employee.id)"
            class="employees__menu" />
        </div>
      </li>
    </ul>

    <BaseBtn
      v-if="configAccess.employees.main === 2"
      @btnClick="updatePopup(true, 'PopupAddNewEmployee')"
      :text="'Добавить сотрудника'" />

    <transition name="fade">
      <Popup
        v-if="popupDelete"
        @popupToggle="togglePopupDelete"
        :inPage="true"
        class="popup--fixed">
        <Delete
          @popupToggle="togglePopupDelete"
          :item="employee" />
      </Popup>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import SortableMixin from "@/mixins/Account/sortable.mixin";
import MenuActionMixin from "@/mixins/Account/menu-action.mixin";

export default {
  name: "AccountEmployees",

  mixins: [
    SortableMixin,
    MenuActionMixin,
  ],

  metaInfo () {
    return {
      title: `Сотрудники - Личный кабинет дилера - ${this.getDealer.name}`,
    }
  },

  components: {
    BaseBtn: () => import('@/components/base/BaseBtn'),
    Popup: () => import('@/elements/Popup/Popup'),
    Delete: () => import('./components/Delete'),
    MenuAction: () => import('@/pages/account/components/MenuAction'),
  },

  data: () => ({
    section: null,
    popupDelete: false,
    employee: null,
  }),

  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      configAccess: state => state.user.configAccess,
    }),

    ...mapGetters('user', [
      'getDealer',
    ]),

    ...mapGetters('account', [
      'getFilteredEmployees',
    ]),

    isEdingAccessPage() {
      return this.configAccess?.employees?.main === 2;
    },

    isViewAccessPage() {
      return this.configAccess?.employees?.main === 1;
    },

    hidePriceAccess() {
      const configAccess = this.configAccess;

      if ((this.isEdingAccessPage || this.isViewAccessPage) && configAccess.access_rights.main === 2) {
        return true;
      }

      return false;
    },
  },

  filters: {
    getFio(name) {
      return name.split(' ').slice(0, 2).map(i => i[0]).join('')
    },
  },

  methods: {
    ...mapActions('account', [
      'pullEmployees',
      'selectEmployee'
    ]),

    ...mapActions('user', [
      'checkLogin',
      'setConfig',
    ]),

    ...mapActions('account/accesses', [
      'rolesLoad',
    ]),

    ...mapActions('account', [
      'setEmployeeInfo',
    ]),

    isDisabledBtn(userId) {
      if (this.isEdingAccessPage) {
        return false;
      }

      return userId !== this.userInfo?.id;
    },

    positionView(employee) {
      this.selectEmployee(employee).then(res => {
        this.updatePopup(true, 'PopupEmployeeView')
      })
    },

    successUpdateHidePriceOrZgi(userId) {
      this.$success('Изменения успешно внесены')
      this.pullEmployees();

      if (userId === this.userInfo?.id) {
        this.checkLogin(false)
      }
    },

    updateConfigDebounce(userId) {
      if (userId === this.userInfo?.id) {
        this.$nextTick(() => {
          this.lodash.debounce(() => {
            this.setConfig({ hide: false });
          }, 1000)();
        });
      }
    },

    hidePriceZgi(id, hide_price_zgi) {
      this.togglePreload();
      this.setEmployeeInfo({
        id,
        data: {
          hide_price_zgi: !hide_price_zgi ? 1 : 0,
        },
      })
        .then(res => {
          this.successUpdateHidePriceOrZgi(id);
          this.updateConfigDebounce(id);
        })
        .catch(error => {
          if (error.response.data.errorMessage) {
            this.$danger(error.response.data.errorMessage)
          } else {
            this.$danger('Ошибка при внесении изменений')
          }
        })
        .finally(() => this.togglePreload())
    },

    hidePrice(id, hide_price) {
      this.togglePreload();
      this.setEmployeeInfo({
        id,
        data: {
          hide_price: !hide_price ? 1 : 0,
        },
      })
        .then(res => {
          this.successUpdateHidePriceOrZgi(id);
        })
        .catch(error => {
          if (error.response.data.errorMessage) {
            this.$danger(error.response.data.errorMessage)
          } else {
            this.$danger('Ошибка при внесении изменений')
          }
        })
        .finally(() => this.togglePreload())
    },

    setActionMenu(id) {
      const menu = []
      const isCurrentUser = this.userInfo.id === id;
      if (this.isEdingAccessPage) {
        menu.push({
          edit: true,
        });

        if (!isCurrentUser) {
          menu.push({
            delete: true,
          })
        }
      } else {
        if (isCurrentUser) {
          menu.push({
            edit: true,
          });
        } else {
          menu.push({
            view: true,
          })
        }
      }

      return menu;
    },

    togglePopupDelete(employee = null) {
      if (employee) {
        this.employee = employee;
      } else {
        this.employee = null;
      }

      this.popupDelete = !this.popupDelete
    },

    toggleSection(str) {
      if (this.section !== str) {
        this.section = str;
      } else {
        this.section = null;
      }
    },

    showUserDataModal(employee) {
      this.selectEmployee(employee).then(res => {
        this.updatePopup(true, 'PopupEmployee')
      })
    },

    closeAddEmployeeModal() {
      this.updatePopup(null, 'PopupAddNewEmployee')
    },
  },

  created() {
    this.togglePreload();
      this.pullEmployees();
      this.rolesLoad()
        .then(res => {
          this.togglePreload();
        });
  },

  beforeDestroy() {
    this.updatePopup(null, null);
  },
}
</script>

<style scoped lang="scss">
.employees {
  padding-bottom: 70px;

  @media(max-width: $desktop) {
    margin-bottom: 20px;
  }

  &__view {
    cursor: text;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: #000;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  &__list {
    margin-bottom: 40px;
  }

  &__item {
    line-height: 0;

    &:nth-child(even) {
      background-color: #f3f3f3;

      .employees__section {
        background-color: #f3f3f3;
      }

      @media(max-width: $desktop) {
        background-color: transparent;
      }
    }

    &--title {
      border-bottom: 2px solid #dee2e6;

      &:nth-child(even) {
        background-color: transparent;
      }

      .employees__panel {
        color: #979797;
      }

      .employees__avatar {
        opacity: 0;
      }

      .employees__name {
        button {
          padding: 0;
          margin: 0;
          background-color: transparent;
          border: none;
          text-decoration: underline;
          color: #979797;
        }
      }
    }
  }

  &__panel {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
    padding: 13px 76px 12px 15px;
    text-align: center;
    position: relative;

    @media(max-width: $desktop) {
      display: none;
      background-color: #f3f3f3;
      box-shadow: inset 0px 4px 30px rgba(65, 68, 71, 0.3);
      padding: 12px 20px 20px;
      margin: 0 -20px;
      width: 100vw;

      &.active {
        display: block;
      }
    }
  }

  &__avatar {
    background: #91D7FF;
    width: 29px;
    height: 29px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #fff;
    margin-right: 15px;
  }

  &__name {
    flex: 1;
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    text-align: left;
    padding-right: 10px;

    @media(max-width: $desktop) {
      font-size: 18px;
      line-height: 18px;
    }
  }

  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 68%;

    &--width {
      .employees__email,
      .employees__phone,
      .employees__post,
      .employees__role,
      .employees__price {
        width: 20%;

        @media(max-width: $desktop) {
          width: 100%;
        }
      }
    }

    @media(max-width: $desktop) {
      display: block;
      width: 100%;
    }
  }

  &__email {
    a {
      text-decoration-line: underline;
      color: #4B9DBD;
    }
  }

  &__email,
  &__phone,
  &__post,
  &__role,
  &__price {
    width: 25%;
    flex-shrink: 0;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;

    @media(max-width: $desktop) {
      margin-bottom: 12px;
      width: 100%;
      font-weight: bold;
      text-align: left;
      padding-right: 0;

      span {
        display: block;
        font-size: 14px;
        line-height: 18px;
        color: #979797;
        margin-bottom: 2px;
        font-weight: normal;
      }
    }

    button:disabled{
      cursor: text;
    }
  }

  &__price {
    span {
      margin-left: 10px;
    }

    button {
      position: relative;
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      width: 14px;
      height: 14px;

      &:last-child {
        margin-left: 40px;
      }

      &:before,
      &:after {
        content: "";
        display: block;
        transition: 0.3s;
        position: absolute;
        box-sizing: border-box;
      }

      &:before {
        width: 100%;
        height: 100%;
        border: 1px solid #000;
        border-radius: 100%;
        top: 0;
        left: 0;
      }

      &:after {
        opacity: 0;
        width: 8px;
        height: 6px;
        left: 3px;
        top: 4px;
        background-image: url('/img/arrow-accept.svg');
        background-repeat: no-repeat;
        background-size: 100% auto;
      }

      &.active {
        &:before {
          background-color: #000;
        }

        &:after {
          opacity: 1;
        }
      }
    }
  }

  &__email {
    @media(max-width: $desktop) {
      padding-right: 39px;
    }
  }

  &__menu {
    position: absolute;
    right: 20px;
    text-align: left;

    @media(max-width: $desktop) {
      position: static;
      margin-top: 20px;
    }
  }

  &__section {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #000;
    text-align: left;
    margin: 0 -20px;
    padding: 7px 20px;
    width: 100vw;

    svg {
      fill: #000;
      width: 32px;
      height: 32px;
      flex-shrink: 0;
    }

    &.active {
      svg {
        transform: rotate(45deg);
      }
    }
  }
}
</style>
